import { z } from 'zod'
import { CourtesyStatus } from '~library/enums'
import {
  assignBenefitsRecordSchema,
  businessCardCommonSchema,
  dateValueSchema,
  enumWithEmpty,
  managerBenefitCommonSchema
} from '~library/models'
import { courtesyArrangementRecordSchema } from './courtesy-arrangement-record'
import { FlightScheduleType } from '@library/enums/flight-schedule-type'

/** data上面部分的suitData */
export const suitCourtesyDataSchema = z.object({
  /**
   * 分類
   * PDBG:超額行李
   * LOUG:貴賓室
   * PRCK:優先劃位櫃檯
   * PRBD:優先登機
   * PRBG:優先裝卸行李
   * */
  type: z.string(),
  /** 券號 */
  couponNo: z.string()
})

/** 購票優惠碼資訊 */
export const assignBenefitsPromoCodeInformationSchema = z.object({
  /** 啟用時間 */
  createTime: dateValueSchema,
  /** 啟用人員 */
  createBy: z.string(),
  /** 優惠碼 */
  promoCode: z.string(),
  /** 訂位代號 */
  pnr: z.string().nullable()
})

/** 禮遇詳細資訊 */
export const assignBenefitsSchema = z.object({
  ...managerBenefitCommonSchema.shape,
  /** 指派禮遇 ID */
  id: z.string(),
  /** 券號 */
  couponNo: z.string(),
  /** 狀態 */
  status: z.enum(CourtesyStatus),
  /** 套裝子項目清單 for 未指派 */
  suitCourtesy: z.array(suitCourtesyDataSchema),
  /** 使用起始時間 */
  useStartTime: z.string(),
  /** 使用截止時間 */
  useEndTime: z.string(),
  /** 來源 */
  source: z.string(),
  /** 建檔日期 */
  createTime: z.string(),
  /** 建檔人員 */
  createBy: z.string(),
  /** 指派禮遇紀錄 */
  assignBenefitsRecord: assignBenefitsRecordSchema.nullable(),
  /** 禮遇安排紀錄 */
  courtesyArrangementRecord: courtesyArrangementRecordSchema.nullable(),
  /** 商務卡資訊 */
  businessCardInformation: businessCardCommonSchema.nullable(),
  /** 安排類型 */
  flightScheduleType: enumWithEmpty(FlightScheduleType),
  /** 購票優惠碼資訊 */
  promoCodeInformation: assignBenefitsPromoCodeInformationSchema
})

/** 指派禮遇紀錄 */
export interface AssignBenefitsRecord extends z.infer<
  typeof assignBenefitsRecordSchema
> {}

/** 禮遇詳細資訊 */
export interface AssignBenefits extends z.infer<typeof assignBenefitsSchema> {}

/** 購票優惠碼資訊 */
export interface AssignBenefitsPromoCodeInformation extends z.infer<
  typeof assignBenefitsPromoCodeInformationSchema
> {}

/** 禮遇安排紀錄 */
export interface AssignBenefitsCourtesyArrangementRecordData extends z.infer<
  typeof courtesyArrangementRecordSchema
> {}
